/* eslint-disable */
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { jwtDecode } from 'jwt-decode';
import { useDataContext } from '../context';

const API_URL = import.meta.env.VITE_API_URL;

function AllEvaluationAssignments() { // เปลี่ยนชื่อให้สื่อความหมาย
  const { data, setData } = useDataContext(); 
  const [cookies] = useCookies(['session']);
  const [name, setName] = useState(null);
  const hasFetched = useRef(false); // ✅ เพิ่มกันยิงซ้ำ

  // 1. Logic หา User (เหมือนเดิม)
  const decodedToken = useMemo(() => {
    try {
        return cookies?.session ? jwtDecode(cookies.session) : null;
    } catch (e) { return null; }
  }, [cookies?.session]);

  useEffect(() => {
    if (decodedToken && data?.getAllEmployees) {
      const foundEmployee = data.getAllEmployees.find(
        (employee) => 
             (employee.username && decodedToken?.initials && employee.username === decodedToken.initials) ||
          (employee.employeeCode && decodedToken?.UserCode && employee.employeeCode === decodedToken.UserCode) ||
          (employee.email && decodedToken?.Email && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
             (employee.username && decodedToken?.initials && employee.username === decodedToken.initials) ||
          (employee.employeeCode && decodedToken?.UserCode && employee.employeeCode === decodedToken.UserCode) ||
          (employee.email && decodedToken?.Email && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.mail && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.preferred_username && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.userPrincipalName && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase())
      );
      setName(foundEmployee);
    }
  }, [decodedToken, data?.getAllEmployees]);

  // 2. Fetch Logic (ปรับปรุงใหม่)
  useEffect(() => {
    // ✅ เช็คว่าถ้ามีข้อมูลดิบอยู่แล้ว ไม่ต้องโหลดใหม่
    if (data?.allEvaluationAssignmentsRaw && data.allEvaluationAssignmentsRaw.length > 0) return;
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;
      try {
        const response = await fetch(`${API_URL}/getAllEvaluationAssignments`);
        const result = await response.json();
        const allRows = result.data || [];

        // ✅ เก็บข้อมูลดิบ (Raw) ลง Context เพื่อให้หน้าอื่น (เช่น index.jsx) ไปใช้คำนวณต่อได้
        setData((prevData) => ({
          ...prevData,
          allEvaluationAssignmentsRaw: allRows, 
        }));

      } catch (error) {
        console.error("Error fetching evaluation assignments:", error);
        hasFetched.current = false;
      }
    };

    fetchData();
  }, []); // ✅ ทำงานแค่ครั้งเดียวตอน Mount

  // 3. Logic การกรองข้อมูล (แยกออกมาทำงานเมื่อ Context เปลี่ยน)
  // ส่วนนี้จะทำงาน Client-side ไม่เปลือง Server
  useEffect(() => {
    if (data?.allEvaluationAssignmentsRaw && name && data.selectedEmployee) {
        let filteredData = [];
        const allRows = data.allEvaluationAssignmentsRaw;

        if (data.selectedEmployee === 'all') {
            filteredData = allRows;
        } else if (data.selectedEmployee === 'pendingEva') {
            filteredData = allRows.filter((row) => 
                row.evaluatorId === name?.employeeCode && row.evaluationStatus === 'Pending'
            );
        } else {
            filteredData = allRows.filter((row) => 
                row.evaluatorId === name?.employeeCode && row.evaluationStatus === 'success'
            );
        }

        setData((prevData) => ({
            ...prevData,
            testGetPendingEvaluations: filteredData, // ตัวแปรเดิมที่ UI เอาไปแสดงผล
        }));
    }
  }, [data?.allEvaluationAssignmentsRaw, data.selectedEmployee, name]);

  return null;
}

export default AllEvaluationAssignments;
